module.exports = __webpack_public_path__ + "img/serve8.02f6d910.png";